export default function EnvironmentBanner() {
  const env = process.env.REACT_APP_ENV || 'development';
  if (env !== 'staging') {
    return null;
  }

  return (
    <div className="env-banner" role="status" data-testid="environment-banner">
      STAGING — not production data
    </div>
  );
}
